import { column, Schema, Table } from '@powersync/web';

const roles = new Table(
  {
    // id column (text) is automatically included
    name: column.text,
    description: column.text,
    created_at: column.text,
    role_key: column.text
  },
  { indexes: {} }
);

const vehicles = new Table(
  {
    vehicle_no: column.text,
    type: column.text,
    model: column.text,
    manufacturer: column.text,
    category: column.text,
    owner_name: column.text,
    phone: column.text,
    email: column.text,
    total_petrol: column.text,
    total_amount: column.text,
    created_at: column.text,
    updated_at: column.text,
    created_by: column.text,
    updated_by: column.text
  },
  { indexes: {} }
);

const vehicle_activities = new Table(
  {
    vehicle_id: column.text,
    entity_id: column.text,
    in_time: column.text,
    out_time: column.text,
    fuel: column.text,
    amount: column.text,
    user_id: column.text,
    status: column.text,
    payment_type: column.text,
    payment_status: column.text,
    created_at: column.text,
    updated_at: column.text,
    fuel_quantity_litre: column.text
  },
  { indexes: {} }
);

export const AppSchema = new Schema({
  vehicles,
  vehicle_activities
});
